import { useState, useEffect, useContext } from 'react';
import preguntaService from '../services/preguntas.js';

export const usePreguntas = () => {

    const getPreguntaActual = (usuario, idEje) => preguntaService.getActual(usuario, idEje); 

    return {  getPreguntaActual };
}